// extracted by mini-css-extract-plugin
export default {"Section":"SchoolImageSection_Section__91l9d","SectionTitle":"SchoolImageSection_SectionTitle__zcoBD","DisplayOptionsLabel":"SchoolImageSection_DisplayOptionsLabel__YEzXW"};